import { render, staticRenderFns } from "./CasesChecklist.vue?vue&type=template&id=39633bde"
import script from "./CasesChecklist.vue?vue&type=script&lang=js"
export * from "./CasesChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports